const postError = ({ dispatch }, payload) => {
  dispatch("notifications/setError", payload, { root: true });
};

export default postError;
